// extracted by mini-css-extract-plugin
export default {"th":"th_th__Nnj8m","title":"th_title__xiZvF","sort":"th_sort__UBI-z","active":"th_active__SArkN"};